import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router';
import { useSnackbar } from 'notistack';
import { SaveResponse } from 'helpers/interfaces';
import { TypeInfo } from 'helpers/enums';

interface IContext {
    isLoading: boolean
    isSaving: boolean
    bulkEditRequest: IBulkEditRequest
    updateRequest: (value: IBulkEditRequest) => void
    doBulkEdit: (request: IBulkEditRequest) => void
}

export interface IBulkEditRequest {
    changeReporter: boolean
    reporter: string
    reporterName: string

    changeAssignee: boolean
    assignee: string

    changeCSAssignee: boolean
    csAssignee: string

    changeType: boolean
    type: string
    typeInfo: string
    issueServiceType?: string

    changeStatus: boolean
    status: string
    numberOfItems: number
}

export let bulkEditContext = React.createContext({} as IContext);

let { Provider } = bulkEditContext;

let BuldEditProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    let { id } = useParams<{ id: string }>();
    let history = useHistory();

    let { enqueueSnackbar } = useSnackbar();

    let [isLoading, setLoading] = useState(true);
    let [isSaving, setSaving] = useState(false);
    let [bulkEditRequest, setBulkEditRequest] = useState<IBulkEditRequest>({
        changeReporter: false,
        reporter: "",
        reporterName: "",
        
        changeAssignee: false,
        assignee: "",

        changeCSAssignee: false,
        csAssignee: "",

        changeType: false,
        type: "",
        typeInfo: "",

        changeStatus: false,
        status: "",
        issueServiceType: '',
        numberOfItems: 0
    })


    useEffect(() => {
        getBulkEditRequest(id);
    }, [])



    let getBulkEditRequest = async (id: string) => {
        try {
            setLoading(true);
            let res = await axios.get('/api/BulkEdit/GetBulkEditRequest', { params: { id } });

            setBulkEditRequest({
                ...bulkEditRequest,
                numberOfItems: res.data.item.numberOfItems
            });

        } catch (er) {

        } finally {
            setLoading(false);
        }
    }

    let doBulkEdit = async (request: IBulkEditRequest) => {
        if (request.typeInfo === TypeInfo.Delivery && !request.issueServiceType) {
            enqueueSnackbar("You must choose Issue service type for this ticket type'", { variant: 'warning' });
            return;
        }

        if (window.confirm(`Are you sure you want to modify selected claims?`) === false)
            return;

        try {
            setSaving(true);

            await axios.post<SaveResponse>('/api/BulkEdit/doBulkEdit', { ...request, requestId: id });
            enqueueSnackbar('Claims updated sucessufully', { variant: 'success' });
            history.push('/', { queue: "" });

        } catch (err) {
            setSaving(false);
        }
    }

    return (
        <Provider
            value={{
                isLoading,
                isSaving,
                bulkEditRequest,
                doBulkEdit,
                updateRequest: setBulkEditRequest
            }}
        >
            {children}
        </Provider>
    )
}

export default BuldEditProvider;